import { Email as BlockheadEmail, getThemeColor } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Email = styled(BlockheadEmail)`
  width: 40px;
  height: 32px;
  color: ${getThemeColor('d3')};
  margin: 34px 30px;
`;
